import { render, staticRenderFns } from "./classifyAction.vue?vue&type=template&id=b58dd10a&scoped=true"
import script from "./classifyAction.vue?vue&type=script&lang=js"
export * from "./classifyAction.vue?vue&type=script&lang=js"
import style0 from "./classifyAction.vue?vue&type=style&index=0&id=b58dd10a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58dd10a",
  null
  
)

export default component.exports